// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Q7CZ","requiredAsterisk":"Info_requiredAsterisk__oOOfe"};